import React from 'react';
import { Button } from '@kajabi/sage-react';
import { useUiResourceContext, useResultContext } from 'common/components/CopyMagic/contexts';
import useDiscard from 'common/components/CopyMagic/hooks/useDiscard';

const DiscardButton = () => {
  const { loading } = useUiResourceContext();
  const { result } = useResultContext();
  const { discard } = useDiscard();

  return (
    <Button
      disabled={!!loading || !result}
      color={Button.COLORS.SECONDARY}
      onClick={() => {
        discard();
      }}
    >
      Discard
    </Button>
  );
};

export default DiscardButton;
